import { clamp, dot, add, scale, subtract, normalize } from './math.js';
import { SPRINT_SPEED, TOWN_LENGTH, WALK_SPEED } from './config.js';
export const TOWN_BOXES = [];
for (let index = 0; index < 14; index++) {
    for (const side of [-1, 1])
        TOWN_BOXES.push({ x: side * 19, z: -18 - index * 24, width: 12, depth: 20, height: 8 + index % 4 * 2, kind: 'building' });
}
for (const [x, z] of [[-6, -42], [6, -92], [-5, -150], [6, -206], [-6, -264]]) {
    TOWN_BOXES.push({ x, z, width: 2.2, depth: 4.6, height: 1.5, kind: 'car' });
}
for (const [x, z] of [[8, -65], [-8, -119], [7, -180], [-7, -238]]) {
    TOWN_BOXES.push({ x, z, width: 2, depth: 2, height: 1.8, kind: 'crate' });
}
/** Input axes only; distance and collision are shared with the authoritative server. */
export function moveTown(position, forward, strafe, yaw, sprint, dt) {
    const magnitude = Math.max(1, Math.hypot(forward, strafe));
    const speed = (sprint ? SPRINT_SPEED : WALK_SPEED) * clamp(dt, 0, 0.1) / magnitude;
    const dx = (strafe * Math.cos(yaw) - forward * Math.sin(yaw)) * speed;
    const dz = (-forward * Math.cos(yaw) - strafe * Math.sin(yaw)) * speed;
    const result = { ...position };
    const free = (x, z) => !TOWN_BOXES.some(box => Math.abs(x - box.x) < box.width / 2 + 0.35 && Math.abs(z - box.z) < box.depth / 2 + 0.35);
    const x = clamp(position.x + dx, -11.5, 11.5);
    if (free(x, result.z))
        result.x = x;
    const z = clamp(position.z + dz, -TOWN_LENGTH - 4, 6);
    if (free(result.x, z))
        result.z = z;
    result.y = 1.68;
    return result;
}
/** Omnidirectional enemy hit volume; works when players turn back or shoot sideways. */
export function raySphereIntersection(ray, center, radius) {
    const direction = normalize(ray.direction);
    const toCenter = subtract(center, ray.origin);
    const along = dot(toCenter, direction);
    const perpendicularSquared = Math.max(0, dot(toCenter, toCenter) - along * along);
    if (perpendicularSquared > radius * radius)
        return null;
    const half = Math.sqrt(radius * radius - perpendicularSquared);
    const distance = along - half > 0 ? along - half : along + half;
    if (distance <= 0 || distance > 300)
        return null;
    return { distance, point: add(ray.origin, scale(direction, distance)), normalizedRadius: Math.sqrt(perpendicularSquared) / radius };
}
/** Slab test against the same town cover that the client renders. */
export function townOcclusionDistance(ray) {
    const direction = normalize(ray.direction);
    let nearest = Infinity;
    for (const box of TOWN_BOXES) {
        let near = 0, far = 300;
        for (const [axis, low, high] of [['x', box.x - box.width / 2, box.x + box.width / 2], ['y', 0, box.height], ['z', box.z - box.depth / 2, box.z + box.depth / 2]]) {
            if (Math.abs(direction[axis]) < 1e-9) {
                if (ray.origin[axis] < low || ray.origin[axis] > high) {
                    far = -1;
                    break;
                }
            }
            else {
                const a = (low - ray.origin[axis]) / direction[axis], b = (high - ray.origin[axis]) / direction[axis];
                near = Math.max(near, Math.min(a, b));
                far = Math.min(far, Math.max(a, b));
            }
        }
        if (far >= near && far > 0)
            nearest = Math.min(nearest, near);
    }
    return nearest;
}
export const isEnemy = (kind) => kind === 'runner' || kind === 'brute' || kind === 'crawler' || kind === 'husk' || kind === 'raider';
//# sourceMappingURL=world.js.map